import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import { set } from 'lodash';

export const validateForUI = (schema, data, customValidation = null, t) => {
  let errorArray = [];
  const errors = {};
  const results = removeBlankFields(data);
  const ajv = new Ajv({ allErrors: true, useDefaults: true });
  addFormats(ajv);
  const validate = ajv.compile(schema);
  if (!validate(results)) {
    errorArray = transformErrorArray(validate.errors, t);
  }
  if (typeof customValidation === 'object' && customValidation !== null) {
    const customErrorArray = customValidation;
    errorArray.push(...customErrorArray);
  }
  errorArray.forEach((error) => set(errors, error.field, error.message));
  return errors;
};

const removeBlankFields = (data) => {
  if (Array.isArray(data)) {
    return data.map((element) => removeBlankFields(element));
  }
  const newData = { ...data };
  const newDataArray = Object.keys(newData);
  newDataArray.forEach((element) => {
    if (newData[element] === '' || newData[element] === null) {
      delete newData[element];
    } else {
      traverse(newData[element]);
    }
  });
  return newData;
};

function traverse(x) {
  if (Array.isArray(x)) {
    traverseArray(x);
  } else if (typeof x === 'object' && x !== null) {
    traverseObject(x);
  }
}

function traverseArray(arr) {
  arr.forEach((x) => {
    traverse(x);
  });
}

function traverseObject(obj) {
  const dataArray = Object.keys(obj);
  dataArray.forEach((key) => {
    if (obj[key] === '' || obj[key] === null) {
      delete obj[key]; // eslint-disable-line no-param-reassign
    } else {
      traverse(obj[key]);
    }
  });
}

const transformErrorArray = (jsonErrorArray, t) => {
  const newArray = [];
  let err = {};
  jsonErrorArray.forEach((jsonError) => {
    let field = jsonError.instancePath;
    // Replace first character if it's a slash
    if (field[0] === '/') {
      field = field.substring(1);
    }
    // Replace first character if it's a period
    if (field[0] === '.') {
      field = field.substring(1);
    }
    // Convert /0/ to [0].
    field = field.replace(/\/\d+\//g, (match) => {
      let string = match;
      string = string.replace('/', '[');
      string = string.replace('/', '].');
      return `${string}`;
    });
    // Convert /0 to [0]
    field = field.replace(/\/\d+/g, (match) => {
      let string = match;
      string = string.replace('/', '[');
      return `${string}]`;
    });
    switch (jsonError.keyword) {
      case 'additionalProperties':
        if (jsonError.instancePath.length > 0) {
          err = {
            field: `${field}.${jsonError.params.additionalProperty}`,
            message: t('general.errorMessages.invalidProperty')
          };
        } else {
          err = {
            field: `${jsonError.params.additionalProperty}`,
            message: t('general.errorMessages.invalidProperty')
          };
        }
        break;
      case 'required':
        if (jsonError.instancePath.length > 0) {
          err = {
            field: `${field}.${jsonError.params.missingProperty}`,
            // message: 'Required'
            message: t('general.errorMessages.required')
          };
        } else {
          err = {
            field: `${jsonError.params.missingProperty}`,
            // message: 'Required'
            message: t('general.errorMessages.required')
          };
        }
        break;
      case 'type':
        err = {
          field: `${field}`,
          message: `${t('general.errorMessages.invalidGeneric')} ${
            jsonError.params.type
          }`
        };
        break;
      case 'maxLength':
      case 'minLength':
      case 'enum':
      case 'minimum':
      case 'pattern':
      case 'format':
        err = {
          field: `${field}`,
          message: jsonError.message
        };
        break;
      default:
        err = {
          field: `${field}`,
          message: jsonError.message
        };
    }
    newArray.push(err);
  });
  return newArray;
};
